import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=2085d338&"
import script from "./Promotion.vue?vue&type=script&lang=js&"
export * from "./Promotion.vue?vue&type=script&lang=js&"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=2085d338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports